import { render } from "./sub-category.vue?vue&type=template&id=e30f534e"
import script from "./sub-category.vue?vue&type=script&lang=js"
export * from "./sub-category.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__